export const stageList = [
  // Educação Infantil (301)
  {
    code: 1,
    label: "Educação infantil - creche (0 a 3 anos)",
    aggregateStage: 301,
    render: {
      "aggregateStage": [301],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },
  {
    code: 2,
    label: "Educação infantil - pré-escola (4 e 5 anos)",
    aggregateStage: 301,
    render: {
      "aggregateStage": [301],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },
  {
    code: 3,
    label: "Educação infantil - unificada (0 a 5 anos)",
    aggregateStage: 301,
    render: {
      "aggregateStage": [301],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },

  // Ensino Fundamental (302)
  {
    code: 14,
    label: "Ensino fundamental de 9 anos - 1º Ano",
    aggregateStage: 302,
    render: {
      "aggregateStage": [302],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },
  {
    code: 15,
    label: "Ensino fundamental de 9 anos - 2º Ano",
    aggregateStage: 302,
    render: {
      "aggregateStage": [302],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },
  {
    code: 16,
    label: "Ensino fundamental de 9 anos - 3º Ano",
    aggregateStage: 302,
    render: {
      "aggregateStage": [302],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },
  {
    code: 17,
    label: "Ensino fundamental de 9 anos - 4º Ano",
    aggregateStage: 302,
    render: {
      "aggregateStage": [302],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },
  {
    code: 18,
    label: "Ensino fundamental de 9 anos - 5º Ano",
    aggregateStage: 302,
    render: {
      "aggregateStage": [302],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },
  {
    code: 19,
    label: "Ensino fundamental de 9 anos - 6º Ano",
    aggregateStage: 302,
    render: {
      "aggregateStage": [302],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },
  {
    code: 20,
    label: "Ensino fundamental de 9 anos - 7º Ano",
    aggregateStage: 302,
    render: {
      "aggregateStage": [302],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },
  {
    code: 21,
    label: "Ensino fundamental de 9 anos - 8º Ano",
    aggregateStage: 302,
    render: {
      "aggregateStage": [302],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },
  {
    code: 41,
    label: "Ensino fundamental de 9 anos - 9º Ano",
    aggregateStage: 302,
    render: {
      "aggregateStage": [302],
      "typeServices.curricularStage": 1,
      "typeServices.complementaryActivity_not": 1,
    }
  },

  // Multi e correção de fluxo (303)
  {
    code: 22,
    label: "Ensino fundamental de 9 anos - multi",
    aggregateStage: 303,
    render: {
      "aggregateStage": [303],
    }
  },
  {
    code: 23,
    label: "Ensino fundamental de 9 anos - correção de fluxo",
    aggregateStage: 303,
    render: {
      "aggregateStage": [303],
    }
  },
  {
    code: 56,
    label: "Educação infantil e ensino fundamental - multietapa",
    aggregateStage: 303,
    render: {
      "aggregateStage": [303],
    }
  },

  // Ensino Médio (304)
  {
    code: 25,
    label: "Ensino médio - 1ª Série",
    aggregateStage: 304,
    render: {
      "aggregateStage": [304],
      "typeServices.curricularStage": 1,
    }
  },
  {
    code: 26,
    label: "Ensino médio - 2ª Série",
    aggregateStage: 304,
    render: {
      "aggregateStage": [304],
      "typeServices.curricularStage": 1,
    }
  },
  {
    code: 27,
    label: "Ensino médio - 3ª Série",
    aggregateStage: 304,
    render: {
      "aggregateStage": [304],
      "typeServices.curricularStage": 1,
    }
  },
  {
    code: 28,
    label: "Ensino médio - 4ª Série",
    aggregateStage: 304,
    render: {
      "aggregateStage": [304],
      "typeServices.curricularStage": 1,
    }
  },
  {
    code: 29,
    label: "Ensino médio - não seriada",
    aggregateStage: 304,
    render: {
      "aggregateStage": [304],
      "typeServices.curricularStage": 1,
    }
  },

  // Ensino Médio - Normal/Magistério (305)
  {
    code: 35,
    label: "Ensino médio - normal/magistério - 1ª Série",
    aggregateStage: 305,
    render: {
      "aggregateStage": [305],
      "typeServices.curricularStage": 1,
    }
  },
  {
    code: 36,
    label: "Ensino médio - normal/magistério - 2ª Série",
    aggregateStage: 305,
    render: {
      "aggregateStage": [305],
      "typeServices.curricularStage": 1,
    }
  },
  {
    code: 37,
    label: "Ensino médio - normal/magistério - 3ª Série",
    aggregateStage: 305,
    render: {
      "aggregateStage": [305],
      "typeServices.curricularStage": 1,
    }
  },
  {
    code: 38,
    label: "Ensino médio - normal/magistério - 4ª Série",
    aggregateStage: 305,
    render: {
      "aggregateStage": [305],
      "typeServices.curricularStage": 1,
    }
  },

  // Educação de Jovens e Adultos (306)
  {
    code: 69,
    label: "EJA - Ensino fundamental - anos iniciais (1º segmento)",
    aggregateStage: 306,
    render: {
      "aggregateStage": [306],
    }
  },
  {
    code: 70,
    label: "EJA - Ensino fundamental - anos finais (2º segmento)",
    aggregateStage: 306,
    render: {
      "aggregateStage": [306],
    }
  },
  {
    code: 72,
    label: "EJA - Ensino fundamental  - anos iniciais e anos finais (EJA Multietapas)",
    aggregateStage: 306,
    render: {
      "aggregateStage": [306],
    }
  },
  {
    code: 71,
    label: "EJA - Ensino médio (3º segmento)",
    aggregateStage: 306,
    render: {
      "aggregateStage": [306],
    }
  },
  {
    code: 74,
    label: "Curso técnico integrado na modalidade EJA (EJA integrada à educação profissional de nível médio)",
    aggregateStage: 306,
    render: {
      "aggregateStage": [306],
    }
  },
  {
    code: 73,
    label: "Curso FIC integrado na modalidade EJA - nível fundamental",
    aggregateStage: 306,
    render: {
      "aggregateStage": [306],
    }
  },
  {
    code: 67,
    label: "Curso FIC integrado na modalidade EJA - nível médio",
    aggregateStage: 306,
    render: {
      "aggregateStage": [306],
    }
  },

  // Curso Técnico e FIC - Concomitante ou Subsequente (308)
  {
    code: 39,
    label: "Curso técnico - concomitante",
    aggregateStage: 308,
    render: {
      "aggregateStage": [308],
    }
  },
  {
    code: 40,
    label: "Curso técnico - subsequente",
    aggregateStage: 308,
    render: {
      "aggregateStage": [308],
    }
  },
  {
    code: 64,
    label: "Curso técnico misto",
    aggregateStage: 308,
    render: {
      "aggregateStage": [308],
    }
  },
  {
    code: 68,
    label: "Curso FIC concomitante",
    aggregateStage: 308,
    render: {
      "aggregateStage": [308],
    }
  },
  {
    code: 65,
    label: "Curso FIC subsequente",
    aggregateStage: 308,
    render: {
      "aggregateStage": [308],
    }
  },
  {
    code: 66,
    label: "Curso FIC misto",
    aggregateStage: 308,
    render: {
      "aggregateStage": [308],
    }
  },
];

function getValueByPath(obj, path) {
  return path.split('.').reduce((acc, key) => acc && acc[key], obj);
}

export function renderStage(stageList, objectClass) {
  for (const [field, value] of Object.entries(stageList)) {
    const realFieldValue = getValueByPath(objectClass, field.replace("_not", ""));

    if (field.endsWith("_not")) {
      if (realFieldValue === value) return false;
    } else {
      if (Array.isArray(value)) {
        if (!value.includes(realFieldValue)) return false;
      } else {
        if (realFieldValue !== value) return false;
      }
    }
  }
  return true;
}
